import store from "@/store";
import {
  PANEL_INFO_CONSTANTS,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";

export type ChatLinkStrategy = (href: string) => void;

export const chatLinkHandlers: Record<string, ChatLinkStrategy> = {
  "Ver servicio": (href: string) => {
    const data = href.split("/");
    store.commit(STORE_CONSTANTS.TO_MAIN_VIEW, {
      from: PANEL_INFO_CONSTANTS.FROM.PANEL,
      type: PANEL_INFO_CONSTANTS.TYPE.SERVICE,
      action: PANEL_INFO_CONSTANTS.ACTION.FILL,
      data: {
        id: data[0],
        type: data[1],
        name: data[2]
      }
    });
  },
  "Ver formulario": (href: string) => {
    const data = href.split("/");

    console.log("data", data);
    store.commit("setEventData", {
      refId: data[0],
      type: "formulario",
      title: data[1],
      notes: []
    });
  },
  "Ver documento": (href: string) => {
    store.commit("setDocumentPathFromChat", href);
  }
};
